import { CommentReportDto, MemoRequestDto, MemoResponseDto } from '@careapp-group/ng-sdk-v2-new';
import { createAction, props } from '@ngrx/store';
import { CareAppListActionFactory } from '../action-factory';

class MemosActions extends CareAppListActionFactory<MemoRequestDto | MemoResponseDto> {
  constructor(modelName: string) {
    super(modelName);
  }
  get REQUEST_CREATE_ACTIONED() {
    return `[${this.type}][Request] Create actioned`;
  }
  get INSTANT_CREATE_COMMENT() {
    return `[${this.type}][Request] Instant create comment`;
  }
  get INSTANT_HEART() {
    return `[${this.type}][Request] Instant heart`;
  }
  get RESPONSE_SUCCESS_CREATE_ACTIONED() {
    return `[${this.type}][Response][Success] Create actioned`;
  }
  get RESPONSE_FAIL_CREATE_ACTIONED() {
    return `[${this.type}][Response][Fail] Create actioned`;
  }
  get REQUEST_ADD_COMMENT() {
    return `[${this.type}][Request] Add comment`;
  }
  get RESPONSE_SUCCESS_ADD_COMMENT() {
    return `[${this.type}][Response][Success] Add comment`;
  }
  get RESPONSE_FAIL_ADD_COMMENT() {
    return `[${this.type}][Response][Fail] Add comment`;
  }
  get REQUEST_ADD_HEART() {
    return `[${this.type}][Request] Add heart`;
  }
  get RESPONSE_SUCCESS_ADD_HEART() {
    return `[${this.type}][Response][Success] Add heart`;
  }
  get RESPONSE_FAIL_ADD_HEART() {
    return `[${this.type}][Response][Fail] Add heart`;
  }
  get REQUEST_REMOVE_HEART() {
    return `[${this.type}][Request] Remove heart`;
  }
  get RESPONSE_SUCCESS_REMOVE_HEART() {
    return `[${this.type}][Response][Success] Remove heart`;
  }
  get RESPONSE_FAIL_REMOVE_HEART() {
    return `[${this.type}][Response][Fail] Remove heart`;
  }
  get REQUEST_LOG_SAVED_FILE() {
    return `[${this.type}][Request] Log saved file`;
  }
  get RESPONSE_SUCCESS_LOG_SAVED_FILE() {
    return `[${this.type}][Response][Success] Log saved file`;
  }
  get RESPONSE_FAIL_LOG_SAVED_FILE() {
    return `[${this.type}][Response][Fail] Log saved file`;
  }

  get REQUEST_SET_COMMENT_VISIBILITY() {
    return `[${this.type}][Request] set comment visibility`;
  }
  get CANCEL_SET_COMMENT_VISIBILITY() {
    return `[${this.type}][Cancel] set comment visibility`;
  }
  get RESPONSE_SUCCESS_SET_COMMENT_VISIBILITY() {
    return `[${this.type}][Response][Success] set comment visibility`;
  }
  get RESPONSE_FAIL_SET_COMMENT_VISIBILITY() {
    return `[${this.type}][Response][Fail] set comment visibility`;
  }

  get REQUEST_PUBLIC_URL() {
    return `[${this.type}][Request] Public URL`;
  }
  get RESPONSE_SUCCESS_PUBLIC_URL() {
    return `[${this.type}][Response][Success] Public URL`;
  }
  get RESPONSE_FAIL_PUBLIC_URL() {
    return `[${this.type}][Response][Fail] Public URL`;
  }

  get REQUEST_PUBLIC_UNSHARE() {
    return `[${this.type}][Request] Public Unshare`;
  }
  get RESPONSE_SUCCESS_PUBLIC_UNSHARE() {
    return `[${this.type}][Response][Success] Public Unshare`;
  }
  get RESPONSE_FAIL_PUBLIC_UNSHARE() {
    return `[${this.type}][Response][Fail] Public Unshare`;
  }

  get REQUEST_REPORT_COMMENT() {
    return `[${this.type}][Request] Report Memo Comment`;
  }
  get RESPONSE_SUCCESS_REPORT_COMMENT() {
    return `[${this.type}][Response][Success] Report Memo Comment`;
  }
  get RESPONSE_FAIL_REPORT_COMMENT() {
    return `[${this.type}][Response][Fail] Report Memo Comment`;
  }

  get REQUEST_ALL_MEMO_COMMENT_REPORTS() {
    return `[${this.type}][Request] Retrieve Memo Comment Reports`;
  }
  get RESPONSE_SUCCESS_ALL_MEMO_COMMENT_REPORTS() {
    return `[${this.type}][Response][Success] Retrieve Memo Comment Reports`;
  }
  get RESPONSE_FAIL_ALL_MEMO_COMMENT_REPORTS() {
    return `[${this.type}][Response][Fail] Retrieve Memo Comment Reports`;
  }
  get REQUEST_DELETE_REPORTS_FOR_COMMENT() {
    return `[${this.type}][Request] Delete reports for comment`;
  }
  get RESPONSE_SUCCESS_DELETE_REPORTS_FOR_COMMENT() {
    return `[${this.type}][Response][Success] Delete reports for comment`;
  }
  get RESPONSE_FAIL_DELETE_REPORTS_FOR_COMMENT() {
    return `[${this.type}][Response][Fail] Delete reports for comment`;
  }

  get REQUEST_DELETE_MEMO_COMMENT() {
    return `[${this.type}][Request] Delete memo comment`;
  }
  get RESPONSE_SUCCESS_DELETE_MEMO_COMMENT() {
    return `[${this.type}][Response][Success] Delete memo comment`;
  }
  get RESPONSE_FAIL_DELETE_MEMO_COMMENT() {
    return `[${this.type}][Response][Fail] Delete memo comment`;
  }

  get REQUEST_APPROVE_MEMO_COMMENT() {
    return `[${this.type}][Request] Approve memo comment`;
  }
  get RESPONSE_SUCCESS_APPROVE_MEMO_COMMENT() {
    return `[${this.type}][Response][Success] Approve memo comment`;
  }
  get RESPONSE_FAIL_APPROVE_MEMO_COMMENT() {
    return `[${this.type}][Response][Fail] Approve memo comment`;
  }

  get REQUEST_ALL_PAGINATED_MEMOS() {
    return `[${this.type}][Request] All (paginated)`;
  }
  get RESPONSE_SUCCESS_ALL_PAGINATED_MEMOS() {
    return `[${this.type}][Response][Success] All (paginated)`;
  }
  get RESPONSE_FAIL_ALL_PAGINATED_MEMOS() {
    return `[${this.type}][Response][Fail] All (paginated)`;
  }

  requestCreateActionedAction = createAction(
    this.REQUEST_CREATE_ACTIONED,
    props<{ memoId: string; body: string; actionType: string }>()
  );

  responseSuccessCreateActionedAction = createAction(
    this.RESPONSE_SUCCESS_CREATE_ACTIONED,
    props<{ memo: MemoResponseDto; actionType: string }>()
  );

  responseFailCreateActionedAction = createAction(
    this.RESPONSE_FAIL_CREATE_ACTIONED,
    props<{ memoId: string; actionType: string; error: any }>()
  );

  requestAddHeartAction = createAction(this.REQUEST_ADD_HEART, props<{ memoId: string }>());

  responseSuccessAddHeartAction = createAction(
    this.RESPONSE_SUCCESS_ADD_HEART,
    props<{ memo: MemoResponseDto }>()
  );

  responseFailAddHeartAction = createAction(
    this.RESPONSE_FAIL_ADD_HEART,
    props<{ memoId: string; error: any }>()
  );

  requestRemoveHeartAction = createAction(this.REQUEST_REMOVE_HEART, props<{ memoId: string }>());

  responseSuccessRemoveHeartAction = createAction(
    this.RESPONSE_SUCCESS_REMOVE_HEART,
    props<{ memo: MemoResponseDto }>()
  );

  responseFailRemoveHeartAction = createAction(
    this.RESPONSE_FAIL_REMOVE_HEART,
    props<{ memoId: string; error: any }>()
  );

  requestLogSavedFileAction = createAction(
    this.REQUEST_LOG_SAVED_FILE,
    props<{ memoId: string; fileId: string }>()
  );

  responseSuccessLogSavedFileAction = createAction(
    this.RESPONSE_SUCCESS_LOG_SAVED_FILE,
    props<{ memo: MemoResponseDto }>()
  );

  responseFailLogSavedFileAction = createAction(
    this.RESPONSE_FAIL_LOG_SAVED_FILE,
    props<{ memoId: string; error: any }>()
  );

  requestAddComment = createAction(
    this.REQUEST_ADD_COMMENT,
    props<{ body: string; roles: string[] }>()
  );

  responseSuccessAddComment = createAction(
    this.RESPONSE_SUCCESS_ADD_COMMENT,
    props<{ memo: MemoResponseDto }>()
  );

  responseFailAddComment = createAction(
    this.RESPONSE_FAIL_ADD_COMMENT,
    props<{ memoId: string; error: any }>()
  );

  requestPublicUrl = createAction(
    this.REQUEST_PUBLIC_URL,
    props<{ memoId: string; body: string }>()
  );

  responseSuccessPublicUrl = createAction(
    this.RESPONSE_SUCCESS_PUBLIC_URL,
    props<{ memoId: string; url: string }>()
  );

  responseFailPublicUrl = createAction(
    this.RESPONSE_FAIL_PUBLIC_URL,
    props<{ memoId: string; error: any }>()
  );

  requestPublicUnshare = createAction(this.REQUEST_PUBLIC_UNSHARE, props<{ memoId: string }>());

  responseSuccessPublicUnshare = createAction(
    this.RESPONSE_SUCCESS_PUBLIC_UNSHARE,
    props<{ memo: MemoResponseDto }>()
  );

  responseFailPublicUnshare = createAction(
    this.RESPONSE_FAIL_PUBLIC_UNSHARE,
    props<{ memoId: string; error: any }>()
  );

  /**
   * Dispatched from request create comment to immediately update the store
   * with the new comment without waiting for network RTT
   */
  instantCreateComment = createAction(
    this.INSTANT_CREATE_COMMENT,
    props<{ memberId: string; memoId: string; body: string; roles: string[] }>()
  );

  instantHeart = createAction(
    this.INSTANT_HEART,
    props<{ memberId: string; memoId: string; hearted: boolean }>()
  );

  requestReportMemoComment = createAction(
    this.REQUEST_REPORT_COMMENT,
    props<{ commentId: string; body: string }>()
  );

  responseSuccessReportMemoComment = createAction(
    this.RESPONSE_SUCCESS_REPORT_COMMENT,
    props<{ report: CommentReportDto }>()
  );

  responseFailReportMemoComment = createAction(
    this.RESPONSE_FAIL_REPORT_COMMENT,
    props<{ commentId: string; body: string; error: any }>()
  );

  requestAllMemoCommentReports = createAction(this.REQUEST_ALL_MEMO_COMMENT_REPORTS);

  responseSuccessAllMemoCommentReports = createAction(
    this.RESPONSE_SUCCESS_ALL_MEMO_COMMENT_REPORTS,
    props<{ reports: CommentReportDto[] }>()
  );

  responseFailAllMemoCommentReports = createAction(
    this.RESPONSE_FAIL_ALL_MEMO_COMMENT_REPORTS,
    props<{ error: any }>()
  );

  requestDeleteReportsForComment = createAction(
    this.REQUEST_DELETE_REPORTS_FOR_COMMENT,
    props<{ commentId: string }>()
  );

  responseSuccessDeleteReportsForComment = createAction(
    this.RESPONSE_SUCCESS_DELETE_REPORTS_FOR_COMMENT,
    props<{ commentId: string }>()
  );

  responseFailDeleteReportsForComment = createAction(
    this.RESPONSE_FAIL_DELETE_REPORTS_FOR_COMMENT,
    props<{ error: any }>()
  );

  requestDeleteMemoComment = createAction(
    this.REQUEST_DELETE_MEMO_COMMENT,
    props<{ commentId: string }>()
  );

  responseSuccessDeleteMemoComment = createAction(
    this.RESPONSE_SUCCESS_DELETE_MEMO_COMMENT,
    props<{ commentId: string }>()
  );

  responseFailDeleteMemoComment = createAction(
    this.RESPONSE_FAIL_DELETE_MEMO_COMMENT,
    props<{ error: any }>()
  );

  requestApproveMemoComment = createAction(
    this.REQUEST_APPROVE_MEMO_COMMENT,
    props<{ commentId: string }>()
  );

  responseSuccessApproveMemoComment = createAction(
    this.RESPONSE_SUCCESS_APPROVE_MEMO_COMMENT,
    props<{ commentId: string }>()
  );

  responseFailApproveMemoComment = createAction(
    this.RESPONSE_FAIL_APPROVE_MEMO_COMMENT,
    props<{ error: any }>()
  );

  requestAllPaginatedMemos = createAction(
    this.REQUEST_ALL_PAGINATED_MEMOS,
    props<{
      filter: { limit?: number; skip?: number; shared?: boolean; hidden?: boolean; type?: string };
      paginator: string;
      clear?: boolean;
    }>()
  );
  responseSuccessAllPaginatedMemos = createAction(
    this.RESPONSE_SUCCESS_ALL_PAGINATED_MEMOS,
    props<{
      filter: { limit?: number; skip?: number; shared?: boolean; hidden?: boolean; type?: string };
      paginator: string;
      items: MemoResponseDto[];
    }>()
  );
  responseFailAllPaginatedMemos = createAction(
    this.RESPONSE_FAIL_ALL_PAGINATED_MEMOS,
    props<{ error: any; paginator: string }>()
  );
}

export const Memos = new MemosActions(`Memos`);
